import { render, TemplateResult } from 'lit';
import mainCss from '../../../styles/main.css?inline';

const sheet = new CSSStyleSheet();
sheet.replaceSync(mainCss);

export abstract class LitComponent extends HTMLElement {
  protected shadow: ShadowRoot | null = null;
  protected isLoading = false;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadow = this.shadowRoot;
    if (this.shadow) {
      this.shadow.adoptedStyleSheets = [sheet];
    }
  }

  connectedCallback(): void {
    this.render();
    this.setupEventListeners();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }

  protected render(): void {
    if (this.shadow) {
      render(this.getTemplate(), this.shadow);
    }
  }

  protected abstract getTemplate(): TemplateResult;

  protected update(): void {
    this.render();
  }

  protected setupEventListeners(): void {
    void 0;
  }

  protected removeEventListeners(): void {
    void 0;
  }

  protected async executeWithLoading<T>(
    operation: () => Promise<T>,
    onStart?: () => void,
    onEnd?: () => void,
    onError?: (error: Error) => void,
  ): Promise<T | void> {
    if (this.isLoading) return;
    this.isLoading = true;
    onStart?.();
    this.render();
    try {
      return await operation();
    } catch (error) {
      try {
        onError?.(error as Error);
      } catch {
        /* Swallow buggy onError hooks so `finally` still runs. */
      }
    } finally {
      this.isLoading = false;
      onEnd?.();
      this.render();
    }
  }
}
